import React, { useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Row, Col, Button } from "react-bootstrap";
import { createCompany } from "../../../middleware/backend_hepler";
import FormInput from "../../../components/FormInput";
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreateCompanyModal = ({ isOpen, onClose, onCompanyCreated  }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    handleSubmit,
    formState: { errors, isValid },
  } = methods;


  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await createCompany(data);
      setLoading(false);
      toast.success("Company created successfully!");
      if (onCompanyCreated) onCompanyCreated();
      setTimeout(onClose, 1000);
    } catch (error) {
      setLoading(false);
      console.error("Error for company creation:", error);
      toast.error("Failed to create company. Please try again.");
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay-edit')) {
      onClose();
    }
  };

    if (!isOpen) return null;

  return (
    <div className="modal-overlay-edit" onClick={handleOverlayClick}>
      <div className="modal-content-edit">
        <h3 className="edit-title">
            <span className="product-title-text">Company</span>
        </h3>
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
            <div className="sections personal-details-sections p-3">
                <h4>Company Details</h4>
                <Row>
                <Col md={6}>
                    <FormInput
                    name="company_name"
                    label="Company Name"
                    registerOptions={{ required: "Company Name is required" }}
                    required
                    />
                </Col>
                <Col md={6}>
                    <FormInput
                    name="company_pincode"
                    label="Company Pincode"
                    type="number"
                    />
                </Col>
                </Row>
            </div>
            <div className="button-container text-center">
                <Button
                variant="success"
                type="submit"
                className="custom-submit-button"
                >
                Submit
                </Button>
                <Button
                className="custom-close-button"
                type="button"
                onClick={onClose}
                >
                    Cancel
                </Button>
            </div>
            </form>
        </FormProvider>
        <ToastContainer />
      </div>
    </div>
  );
};

export default CreateCompanyModal;
